const indexItems = [
  { title: '七月新番完整列表', count: '28部', tag: '日漫' },
  { title: '国漫人气TOP20合集', count: '20部', tag: '国漫' },
  { title: '韩漫连载追更指南', count: '35部', tag: '韩漫' },
  { title: '经典老番怀旧专区', count: '120部', tag: '经典' },
  { title: '热血战斗番大赏', count: '56部', tag: '日漫' },
  { title: '恋爱日常番精选', count: '42部', tag: '日漫' },
  { title: '悬疑智斗番合集', count: '18部', tag: '日漫' },
  { title: '国漫仙侠玄幻专题', count: '33部', tag: '国漫' },
  { title: '周末一口气追完', count: '15部', tag: '推荐' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100/70">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          专题合集
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 flex items-center justify-between gap-3 hover:bg-background-50 transition-colors duration-200 cursor-pointer"
            >
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-400 mt-1 inline-block">
                  共{item.count}
                </span>
              </div>
              <span className="flex-shrink-0 text-xs font-medium bg-accent-50 text-accent-600 px-2.5 py-1 rounded-full">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}